import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import HttpClient from "../HttpClient";
import {GetListResult} from "react-admin";
import moment from "moment";
import Op from "../interfaces/SequalizeFilters/SequalizeTypes";
import {ComboResponse} from "../interfaces/Combo/ComboResponse";
import {PaymentModeEnum} from "../enums/PaymentModeEnum";

export default class ComboService {
    private basePath = '/centaurus/discount-coupon-order';

    private processDateRangeFilter(filters: any) {
        let where;
        if (filters.expireAt) {
            where = {
                [Op.lte.toString()]: moment(filters.expireAt).toDate()
            }
        }
        return {expireAt: where};
    }

    async getAllCombos(
        limit: number,
        offset: number,
        filters: any,
        sort: any
        ): Promise<GetListResult<ComboResponse>> {
        try {
            let filter = ConstructSequelizeFilters(
            { ...filters },
            [],
            ['paymentStatus', 'createdAt', 'customerPhoneNumber', 'productType']
            );

            let customFilters = this.processDateRangeFilter(filters);

            filters = {
            ...filter,
            ...customFilters
            };

            const response = await HttpClient.get(`${this.basePath}`, {
            params: {
                limit,
                offset,
                filters,
                sort
            }
            });

            return {
            data: response?.data?.data ?? [],
            total: response?.data?.count ?? 0
            };

        } catch (error: any) {
            if (
            error?.response?.status === 400 &&
            error?.response?.data?.error === "Customer not found"
            ) {
            return {
                data: [],
                total: 0
            };
            }

            throw error;
        }
    }


    async getDetailsById(id: number) {
        return await HttpClient.get(`${this.basePath}/${id}`);
    }

    async getAllLapsedVisitsOfCombo(id: number) {
        let data = await HttpClient.get(`${this.basePath}/${id}/lapsed-visits`);
        return data?.data
    }

    async createCombo(id: number, payload: any) {
        return await HttpClient.post(`${this.basePath}/customer/${id}`, payload);
    }

    async refundCombo(id: number, payload: any) {
        return await HttpClient.post(`${this.basePath}/${id}/refund`, payload);
    }

    async markComboAsPaid(id: number, paymentMode: PaymentModeEnum) {
        const data = await HttpClient.post(`${this.basePath}/${id}/mark-as-paid`, {
            paymentMode,
        });
        return data?.data;
    }

    async sendPaymentLink(id: number) {
        let data = await HttpClient.post(`${this.basePath}/${id}/send-payment-link`)
        return data?.data;
    }

    async extendCouponExpiry(id: number, extendExpiryDays: number) {
        return await HttpClient.post(
            `${this.basePath}/${id}/extend-expiry`,
            {},
            {
                params: {
                    extendExpiryDays,
                },
            },
        );
    }

    async sendExtensionPaymentLink(extensionRequestId: number) {
        const data = await HttpClient.post(
            `${this.basePath}/extend-expiry/${extensionRequestId}/send-payment-link`,
        );
        return data?.data;
    }

    async getExpiryExtensionRequestsByUser(userId: number) {
        const data = await HttpClient.get(
            `${this.basePath}/expiry-extension-requests`,
            {
                params: { userId },
            },
        );
        return data?.data;
    }

    async getExpiryExtensionRequestById(id: number) {
        const data = await HttpClient.get(
            `${this.basePath}/expiry-extension-requests/${id}`,
        );
        return data?.data;
    }

    async getAllDiscountCouponSku(
        limit: number,
        offset: number,
        filters:any
    ) {
        let data = await HttpClient.get(`/centaurus/v1/discount-coupon-sku/all`,
            {
                params: {
                    filters,
                    limit,
                    offset,
                    sort: { "field" : "id" , "order":"DESC" }
                },
            })
        return data?.data;
    }
    async calculateComboDiscount(payload : any){
        console.log(payload);
        
        let data = await HttpClient.get(`/centaurus/one-meal-service/combo-discount-price`,{ 
            params: {
                ...payload,
            }
        });
        return data?.data;
    }
}
